import { h, Component } from 'preact'
import { route } from 'preact-router'

import { connect } from 'app/store'
import Landing from 'app/pages/Landing'

class PrivateRoute extends Component {
  render(props) {
    const { component, auth } = props

    if (!auth.accessToken) {
      return <Landing /> 
    }

    return h(component, {...props})
  }
}

export default connect(
  'auth',
  PrivateRoute,
)



// WEBPACK FOOTER //
// ./components/PrivateRoute.js